import TopBanner from "../StylisticComponents/TopBanner";

const steps = [
    {
        number: "01",
        title: "Discovery",
        icon: "images/people.png",
        description: "We start with a free consultation to understand your business, your goals, and the audience you're trying to reach. No templates — just honest questions and careful listening."
    },
    {
        number: "02",
        title: "Strategy",
        icon: "images/market-analysis.png",
        description: "From what we learn, we build a tailored plan that maps your objectives to the right mix of services and channels. You'll know exactly what we're doing and why before any work begins."
    },
    {
        number: "03",
        title: "Creative",
        icon: "images/creative.png",
        description: "We bring the strategy to life — from visual design and copywriting to content production. Every deliverable is built to reflect your brand and move your audience."
    },
    {
        number: "04",
        title: "Delivery",
        icon: "images/campaign.png",
        description: "We execute with precision, hitting timelines and keeping you in the loop at every stage. No surprises — just clear communication and consistent output."
    },
    {
        number: "05",
        title: "Growth & Support",
        icon: "images/leadership.png",
        description: "After launch, we stay engaged. We track performance, surface what's working, and keep refining so your results continue to compound over time."
    }
];

function HowWeWork() {
    return (
        <div>
            <TopBanner>
                <h1 className="display-4 white-text hind-mysuru-bold">How We Work</h1>
                <p className="main-font description-text white-text">We keep things straightforward. Here's what working with MapleMark Media looks like — from first conversation to long-term growth.</p>
            </TopBanner>

            <div className="container">
                <div className="mt-5"></div>
                <div className="row mb-4">
                    <h1 className="bebas-neue-regular orange-text">Here's How It Works</h1>
                </div>

                {steps.map((step, index) => (
                    <div key={step.number} className={`row align-items-center process-step-row ${index < steps.length - 1 ? 'process-step-divider' : ''}`}>
                        <div className="col-2 col-md-1 text-center">
                            <span className="process-step-number bebas-neue-regular orange-text">{step.number}</span>
                        </div>
                        <div className="col-3 col-md-2 text-center">
                            <img src={step.icon} alt={step.title} className="process-step-icon" />
                        </div>
                        <div className="col-7 col-md-9">
                            <h3 className="hind-mysuru-semibold blue-text mb-1">{step.title}</h3>
                            <p className="main-font process-step-desc">{step.description}</p>
                        </div>
                    </div>
                ))}

                <div className="mt-5 mb-5 text-center">
                    <p className="main-font process-cta-text">Ready to get started?</p>
                    <a href="/contact" className="contact-button-nav">Book a Free Consultation</a>
                </div>
            </div>
        </div>
    );
}

export default HowWeWork;
